var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginPopupBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_35415)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15,
    filter: "url(#filter0_f_1648_35415)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.5 289C385.741 289 432 242.358 432 185C432 127.642 385.741 81 328.5 81C271.259 81 225 127.642 225 185C225 242.358 271.259 289 328.5 289Z",
    stroke: "#516CD3",
    strokeWidth: 30
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    filter: "url(#filter1_f_1648_35415)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.5 1038C322.849 1038 400 960.465 400 865C400 769.535 322.849 692 227.5 692C132.151 692 55 769.535 55 865C55 960.465 132.151 1038 227.5 1038Z",
    stroke: "#516CD3",
    strokeWidth: 50
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15,
    filter: "url(#filter2_f_1648_35415)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M328.5 379C435.446 379 522 291.84 522 184.5C522 77.1597 435.446 -10 328.5 -10C221.554 -10 135 77.1597 135 184.5C135 291.84 221.554 379 328.5 379Z",
    stroke: "#516CD3",
    strokeWidth: 30
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    filter: "url(#filter3_f_1648_35415)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.5 1145C381.496 1145 506 1019.23 506 864.5C506 709.77 381.496 584 227.5 584C73.5038 584 -51 709.77 -51 864.5C-51 1019.23 73.5038 1145 227.5 1145Z",
    stroke: "#516CD3",
    strokeWidth: 50
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.24,
    filter: "url(#filter4_f_1648_35415)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1352 163C1413.03 163 1462 113.027 1462 52C1462 -9.02713 1413.03 -59 1352 -59C1290.97 -59 1242 -9.02713 1242 52C1242 113.027 1290.97 163 1352 163Z",
    stroke: "#516CD3",
    strokeWidth: 50
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    filter: "url(#filter5_f_1648_35415)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1355.5 1143C1437.66 1143 1504 1075.92 1504 993.5C1504 911.08 1437.66 844 1355.5 844C1273.34 844 1207 911.08 1207 993.5C1207 1075.92 1273.34 1143 1355.5 1143Z",
    stroke: "#516CD3",
    strokeWidth: 40
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    filter: "url(#filter6_f_1648_35415)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1355.5 1239C1490.15 1239 1599 1128.92 1599 993.5C1599 858.082 1490.15 748 1355.5 748C1220.85 748 1112 858.082 1112 993.5C1112 1128.92 1220.85 1239 1355.5 1239Z",
    stroke: "#516CD3",
    strokeWidth: 40
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1648_35415",
    x: 156,
    y: 12,
    width: 345,
    height: 346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27,
    result: "effect1_foregroundBlur_1648_35415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1648_35415",
    x: -24,
    y: 613,
    width: 503,
    height: 504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27,
    result: "effect1_foregroundBlur_1648_35415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1648_35415",
    x: 66,
    y: -79,
    width: 525,
    height: 527,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27,
    result: "effect1_foregroundBlur_1648_35415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1648_35415",
    x: -130,
    y: 505,
    width: 715,
    height: 719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27,
    result: "effect1_foregroundBlur_1648_35415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1648_35415",
    x: 1163,
    y: -138,
    width: 378,
    height: 380,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27,
    result: "effect1_foregroundBlur_1648_35415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1648_35415",
    x: 1133,
    y: 770,
    width: 445,
    height: 447,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27,
    result: "effect1_foregroundBlur_1648_35415"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1648_35415",
    x: 1038,
    y: 674,
    width: 635,
    height: 639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27,
    result: "effect1_foregroundBlur_1648_35415"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_35415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPopupBg);
export default __webpack_public_path__ + "static/media/LoginPopupBG.c31b08f3b19c7b258f51a7fb5e8a8e48.svg";
export { ForwardRef as ReactComponent };